import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { FiMenu } from "react-icons/fi";
import { Loader } from "../../../../components/Loader/Loader";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import MaintenanceDropDownFilter from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import {
  FSNAnalysis,
  FSNAnalysisFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

const financialYearMonths = [
  { name: "April", id: "04" },
  { name: "May", id: "05" },
  { name: "June", id: "06" },
  { name: "July", id: "07" },
  { name: "August", id: "08" },
  { name: "September", id: "09" },
  { name: "October", id: "10" },
  { name: "November", id: "11" },
  { name: "December", id: "12" },
  { name: "January", id: "01" },
  { name: "February", id: "02" },
  { name: "March", id: "03" },
];

export const FsnAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, FSNAnalysisdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );
  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const Firm = Cookies.get("Firm");

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;

    return `${year}${monthValue}`; // ex: 202404
  };

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);



  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState("");

  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState([]);

  const [selectedItemGroup, setSelectedItemGroup] = useState("");
  const [selectedItemGroupId, setSelectedItemGroupId] = useState([]);

  const [selectedItemName, setSelectedItemName] = useState("");
  const [selectedItemNameId, setSelectedItemNameId] = useState([]);

  useEffect(() => {
    dispatch(StoreFilters());
    dispatch(
      FSNAnalysis({
        firm: Firm,
        IdxMonthNameIDs: selectedMonthId
          ? getMonthId(String(selectedMonthId).padStart(2, "0"))
          : getMonthId("04"),
      }),
    );
  }, [dispatch, Firm]);

  const [filter, setFilter] = useState({
    bookName: [],
    Month: [],
    itemGroup: [],
    itemName: [],
  });

  const [search, setSearch] = useState({
    bookName: "",
    Month: "",
    itemGroup: "",
    itemName: "",
  });

  const bookNameList =
    StoreFiltersdata?.Inwardbook?.map((item) => ({
      label: item.TransactionName,
      value: item.TransactionTypeID,
    })) || [];

  const monthList =
    financialYearMonths?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const itemSubGroupList =
    StoreFiltersdata?.ItemSGroup?.map((item) => ({
      label: item.ItemSubGroupName,
      value: item.ItemSubGroupID,
    })) || [];

  const itemNameList =
    StoreFiltersdata?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];


      // Month => Single Select
      if (type === "Month") {
        return {
          ...prev,
          [type]: selected.includes(item.value) ? [] : [item.value],
        };
      }

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const handleSubmit = () => {
    dispatch(FSNAnalysisFun());
    dispatch(
      FSNAnalysis({
        firm: Firm,
        IdxMonthNameIDs: selectedMonthId
          ? getMonthId(String(selectedMonthId).padStart(2, "0"))
          : getMonthId("04"),
        BookIDs: filter.bookName.toString(),
        ItemSubGrpIDs: filter.itemGroup.toString(),
        ItemIDs: filter.itemName.toString(),
      }),
    );

    setShowFilter(false)
  };

  const handleSubmit1 = () => {
    dispatch(FSNAnalysisFun());
    dispatch(
      FSNAnalysis({
        firm: Firm,
        IdxMonthNameIDs: selectedMonthId
          ? getMonthId(String(selectedMonthId).padStart(2, "0"))
          : getMonthId("04"),
        BookIDs: selectedProductionId.join(","),
        ItemSubGrpIDs: selectedItemGroupId.join(","),
        ItemIDs: selectedItemNameId.join(","),
      }),
    );
  };

  const columns = [
    {
      label: "Class",
      key: "class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Count",
      key: "itemcount",
      align: "left",
    },
    { label: "Issued Qty", key: "Outward", align: "right", format: "true" },
    { label: "Issued Amt", key: "OutwardAmt", align: "right", format: "true" },
    { label: "Cons. %", key: "ConsPct", align: "right", format: "true" },
    { label: "Closing Qty", key: "Closing", align: "right", format: "true" },
    { label: "Stock %", key: "StockPct", align: "right", format: "true" },
  ];

  const initialData = (FSNAnalysisdata?.Summ || []).map((row) => ({
    class: row.class,
    itemcount: row.itemcount,
    Outward: row.Outward,
    OutwardAmt: row.OutwardAmt,
    ConsPct: row.ConsPct,
    Closing: row.Closing || "",
    StockPct: row.StockPct || "",
  }));

  const columns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "itemname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Unit",
      key: "UnitName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "Opening Qty", key: "Opening", align: "right", format: "true" },
    { label: "Inward Qty", key: "Inward", align: "right", format: "true" },
    {
      label: "Issue Qty ",
      key: "Outward",
      align: "right",
      format: "true",
    },
    {
      label: "Issue Amt",
      key: "OutwardAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Closing Qty",
      key: "Closing",
      align: "right",
      format: "true",
    },
    {
      label: "Stock Value",
      key: "StockValue",
      align: "right",
      format: "true",
    },
    {
      label: "Cons %",
      key: "ConsPct",
      align: "right",
      format: "true",
    },
    {
      label: "Cum Cons %",
      key: "ProgressiveConsPct",
      align: "right",
      format: "true",
    },
    {
      label: "Stock %",
      key: "StockPct",
      align: "right",
      format: "true",
    },
    {
      label: "Class",
      key: "Class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
  ];

  const initialData1 = (FSNAnalysisdata?.Dtl || []).map((row) => ({
    itemname: row.itemname,
    UnitName: row.UnitName,
    Rate: row.Rate,
    Opening: row.Opening || "",
    Inward: row.Inward || "",
    Outward: row.Outward || "",
    OutwardAmt: row.OutwardAmt || "",
    Closing: row.Closing || "",
    StockValue: row.StockValue || "",
    ConsPct: row.ConsPct || "",
    ProgressiveConsPct: row.ProgressiveConsPct || "",
    StockPct: row.StockPct || "",
    Class: row.Class || "",
    //   Inward: row.Inward || "",
  }));

  // 🔷 Date

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!FSNAnalysisdata || FSNAnalysisdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <MaintenanceFilterBox
              title="Boook Name"
              items={bookNameList}
              search={search.bookName}
              setSearch={(val) => handleSearch("bookName", val)}
              selectedItems={filter.bookName}
              toggleItem={(item) => toggleItem("bookName", item)}
              selectAll={() => selectAll("bookName", bookNameList)}
            />

            <MaintenanceFilterBox
              title="Month"
              items={monthList}
              search={search.Month}
              setSearch={(val) => handleSearch("Month", val)}
              selectedItems={filter.Month}
              toggleItem={(item) => toggleItem("Month", item)}
              selectAll={() => selectAll("Month", monthList)}
            />

            <MaintenanceFilterBox
              title="Machine Name"
              items={itemSubGroupList}
              search={search.itemGroup}
              setSearch={(val) => handleSearch("itemGroup", val)}
              selectedItems={filter.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)}
              selectAll={() => selectAll("itemGroup", itemSubGroupList)}
            />

            <MaintenanceFilterBox
              title="Item Name"
              items={itemNameList}
              search={search.itemName}
              setSearch={(val) => handleSearch("itemName", val)}
              selectedItems={filter.itemName}
              toggleItem={(item) => toggleItem("itemName", item)}
              selectAll={() => selectAll("itemName", itemNameList)}
            />
            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDownFilter
              label="Book Name "
              data={bookNameList}
              selectedValue={selectedProduction}
              setSelectedValue={setSelectedProduction}
              selectedId={selectedProductionId}
              setSelectedId={setSelectedProductionId}
              placeholder="Select BookName"
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDownFilter
              label="Month"
              data={monthList}
              selectedValue={selectedMonth}
              setSelectedValue={setSelectedMonth}
              selectedId={selectedMonthId}
              setSelectedId={setSelectedMonthId}
              placeholder="Select Month"
              isMulti={false}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDownFilter
              label="Item SubGroup"
              data={itemSubGroupList}
              selectedValue={selectedItemGroup}
              setSelectedValue={setSelectedItemGroup}
              selectedId={selectedItemGroupId}
              setSelectedId={setSelectedItemGroupId}
              placeholder="Select Item Group"
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDownFilter
              label="Item Name"
              data={itemNameList}
              selectedValue={selectedItemName}
              setSelectedValue={setSelectedItemName}
              selectedId={selectedItemNameId}
              setSelectedId={setSelectedItemNameId}
              placeholder="Select Item Name"
            />
          </Col>

          {/* BUTTON */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mt-3 hover-scale-btn "
          >
            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          FSN ANALYSIS
        </div>

        <MaintenanceTable columns={columns} data={initialData} />
      </div>

      <div
        style={{
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          FSN ANALYSIS
        </div>

        <MaintenanceTable columns={columns1} data={initialData1} />
      </div>

      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FsnAnalysis;
